import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Right from "./Right";

function Settings() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div className="d-flex align-items-center mb-3">
                <Link
                  onClick={() => navigate(-1)}
                  className="icon-shape me-3 icon-lg bg-light-red rounded-circle"
                >
                  <i className="bi bi-chevron-left fs-3 text-primary"></i>
                </Link>
                <div>
                  <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                    Account Settings
                  </h3>
                  <p className="lh-sm fw-normal m-0">
                    Manage account details / update.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-4">
                <div className="p-4">
                  <div>
                    <Link
                      to="/edit-profile"
                      className="d-flex justify-content-between align-items-center mb-2"
                    >
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-lg bg-light-dark rounded-circle">
                          <i className="bi bi-gear fs-3 text-dark"></i>
                        </div>
                        <div className="ms-3">
                          <h5 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                            Edit / Update Profile
                          </h5>
                          <p className="d-flex align-items-center text-secondary m-0 lh-1">
                            Update your profile details
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-sm bg-light rounded-circle">
                          <i className="bi bi-chevron-right fs-4 text-dark"></i>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/partner-preferences"
                      className="d-flex justify-content-between align-items-center mb-2"
                    >
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-lg bg-light-dark rounded-circle">
                          <i className="bi bi-people fs-3 text-dark"></i>
                        </div>
                        <div className="ms-3">
                          <h5 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                            Partner Preferences
                          </h5>
                          <p className="d-flex align-items-center text-secondary m-0 lh-1">
                            Update your Partner Preferences
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-sm bg-light rounded-circle">
                          <i className="bi bi-chevron-right fs-4 text-dark"></i>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/unlocked-profile"
                      className="d-flex justify-content-between align-items-center mb-2"
                    >
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-lg bg-light-dark rounded-circle">
                          <i className="bi bi-unlock fs-3 text-dark"></i>
                        </div>
                        <div className="ms-3">
                          <h5 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                            Unlocked Profiles
                          </h5>
                          <p className="d-flex align-items-center text-secondary m-0 lh-1">
                            View all unlocked profiles
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-sm bg-light rounded-circle">
                          <i className="bi bi-chevron-right fs-4 text-dark"></i>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/payment"
                      className="d-flex justify-content-between align-items-center mb-2"
                    >
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-lg bg-light-dark rounded-circle">
                          <i className="bi bi-wallet2 fs-3 text-dark"></i>
                        </div>
                        <div className="ms-3">
                          <h5 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                            Payment History
                          </h5>
                          <p className="d-flex align-items-center text-secondary m-0 lh-1">
                            View all payments made till now
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="icon-shape icon-sm bg-light rounded-circle">
                          <i className="bi bi-chevron-right fs-4 text-dark"></i>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default Settings;
